import { styled } from '@mui/material';

export const CustomStatusList = styled('ul')({ listStyle: 'none', paddingLeft: 0 });
